const theme_nature = {
  id: 4,
  name: "nature",
  displayName: "Nature",
  themeBaseType: "dark",
  themeVariables: {
    COLORS: {
      ACCENT: "#3b8064",
      SECONDARY: "#9CAFBF",
      SURFACE: "#202224",
      SURFACE_LIGHTER: "#27292d",
      RECEIVE_BUBBLE: "#27292d",
      BACKGROUND: "#1b1f21",
      APP_BACKGROUND: "#1b1f21",
      ON_ACCENT: "#FFFFFF",
      ON_SURFACE: "#FFFFFF",
      ON_BACKGROUND: "#FFFFFF",
    },
    BUTTON: {
      BORDER_RADIUS: "25px",
      SHADOW: "0 0 16px 0px rgba(0, 0, 0, 0.3)",
    },
    CONTAINER: {
      BORDER_RADIUS: "12px",
      SHADOW: "0px 0px 13px 1px rgba(0, 0, 0, 0.1)",
    },
    LIST: {
      BORDER_RADIUS: "15px",
    },
  },
};

export default theme_nature;
